import { render, staticRenderFns } from "./UserCategories.vue?vue&type=template&id=39f90248&scoped=true&"
import script from "./UserCategories.vue?vue&type=script&lang=js&"
export * from "./UserCategories.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-categories.scss?vue&type=style&index=0&id=39f90248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f90248",
  null
  
)

export default component.exports